const initialState = {
  data: {},
  loaded: false,
};
export default initialState;
